export default __webpack_public_path__ + "static/booking-ba47aa7647da22d8edb3fda43e3d970c.jpeg";